import { render, staticRenderFns } from "./PreviewForm14.vue?vue&type=template&id=0b88a1e2&scoped=true"
import script from "./PreviewForm14.vue?vue&type=script&lang=ts"
export * from "./PreviewForm14.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b88a1e2",
  null
  
)

export default component.exports